// Countries offered in the sign-up form: name, ISO code (for the flag), dial code and how many digits a local number has.
export const COUNTRIES = [
  { name: "Botswana", code: "BW", dial: "+267", local: 8 },
  { name: "South Africa", code: "ZA", dial: "+27", local: 9 },
  { name: "Namibia", code: "NA", dial: "+264", local: 8 },
  { name: "Zambia", code: "ZM", dial: "+260", local: 9 },
  { name: "Zimbabwe", code: "ZW", dial: "+263", local: 9 },
  { name: "Mozambique", code: "MZ", dial: "+258", local: 8 },
  { name: "Tanzania", code: "TZ", dial: "+255", local: 9 },
  { name: "Uganda", code: "UG", dial: "+256", local: 9 },
  { name: "Kenya", code: "KE", dial: "+254", local: 9 },
  { name: "Nigeria", code: "NG", dial: "+234", local: 10 },
  { name: "Ghana", code: "GH", dial: "+233", local: 9 },
  { name: "United States", code: "US", dial: "+1", local: 10 },
];

export const byName = (name) => COUNTRIES.find((c) => c.name === name);
export const byDial = (dial) => COUNTRIES.find((c) => c.dial === dial);
